const closecircleX = (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#A6A6A6"/>
    <path d="M21.5 12.5L12.5 21.5M12.5 12.5L21.5 21.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)

export default closecircleX
